import { TeamWidget } from "@/components/project/TeamWidget";
import ProjectUpdatesTab from "@/components/project/ProjectUpdatesTab";

import type { DBProject } from "@/lib/db-types";
import type { ProjectOwnerWithUser, BudgetLineRow, TimeEntry } from "@/hooks/use-project-detail";
import type { UserLookup } from "@/hooks/use-users";

interface ProjectSidebarProps {
  project: DBProject;
  owners: ProjectOwnerWithUser[];
  allUsers: UserLookup[];
  budgetLines: BudgetLineRow[];
  timeEntries: TimeEntry[];
  userMap: Map<string, UserLookup>;
  hideTeamWidget?: boolean;
}

export function ProjectSidebar({
  project: p,
  owners,
  allUsers,
  budgetLines,
  timeEntries,
  userMap,
  hideTeamWidget = false,
}: ProjectSidebarProps) {
  return (
    <div className="xl:col-span-4 space-y-8">
      {!hideTeamWidget && (
        <TeamWidget
          projectId={p.id}
          projectUpdatedAt={p.updated_at}
          owners={owners}
          productionLeadId={p.production_lead_id}
          advisorId={p.advisor_id}
          allUsers={allUsers}
          budgetLines={budgetLines}
          timeEntries={timeEntries}
          userMap={userMap}
        />
      )}
      <ProjectUpdatesTab projectId={p.id} users={allUsers} />
    </div>
  );
}
